import { render, staticRenderFns } from "./StudyPrograms.vue?vue&type=template&id=b2e68868&scoped=true&"
import script from "./StudyPrograms.vue?vue&type=script&lang=ts&"
export * from "./StudyPrograms.vue?vue&type=script&lang=ts&"
import style0 from "./StudyPrograms.vue?vue&type=style&index=0&id=b2e68868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e68868",
  null
  
)

export default component.exports